import Raven from 'raven-js';

/*

  This temporarily fixes an issue with /conversations-threads/v1/thread-attributes/{threadId}/delivery-identifiers endpoint
  the endpoint is returning multiple/duplicate recipient delivery identifiers, the difference being whitespace formatting in phone numbers
  /conversations-channels/v1/quota endpoint is only configured for a list of 1 recipients, so this fails

  For now, this resolves the issue as session quota is only for WhatsApp, which should only ever be 1:1 conversations

*/

export const trimVisitorDeliveryIdentifiersForQuotaRequest = data => {
  if (data.length > 1) {
    Raven.captureException(new Error(`Multiple recipient/visitor delivery identifiers in session quota request`), {
      extra: {
        deliveryIdentifiers: data
      }
    });
  }
  return [data[0]];
};